module.exports = __webpack_public_path__ + "img/JP_WOMAN_TALKING.63386cf2.png";